import { Download } from 'lucide-react';
import { TranscriptionSegment } from '@/hooks/useTranscription';
import { downloadSRT, downloadVTT } from '@/lib/subtitles';

interface FormatExporterProps {
  segments: TranscriptionSegment[];
  filename?: string;
  disabled?: boolean;
}

/**
 * 字幕格式匯出按鈕群組
 */
export function FormatExporter({ segments, filename = 'subtitle', disabled }: FormatExporterProps) {
  const handleExportSRT = () => {
    downloadSRT(segments, filename);
  };

  const handleExportVTT = () => {
    downloadVTT(segments, filename);
  };

  const buttonBase = `
    flex items-center gap-2 px-4 py-2
    border-2 border-black rounded-lg font-semibold text-sm
    transition-all duration-100
    disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed
  `;

  return (
    <div className="flex gap-2">
      <button
        onClick={handleExportSRT}
        disabled={disabled || segments.length === 0}
        className={`${buttonBase} bg-[#FFD93D] hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[4px_4px_0_#1A1A1A] active:translate-x-1 active:translate-y-1 active:shadow-none`}
      >
        <Download className="w-4 h-4" />
        SRT
      </button>
      <button
        onClick={handleExportVTT}
        disabled={disabled || segments.length === 0}
        className={`${buttonBase} bg-[#6FEDD6] hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[4px_4px_0_#1A1A1A] active:translate-x-1 active:translate-y-1 active:shadow-none`}
      >
        <Download className="w-4 h-4" />
        VTT
      </button>
    </div>
  );
}
